// extracted by mini-css-extract-plugin
export default {"container":"FrontLayout_container__BSTTx","mobile":"FrontLayout_mobile__XWbdX","sticky":"FrontLayout_sticky__ueFYJ","outlet":"FrontLayout_outlet__XFCh9"};